/**
 * Created by FLI on 2015-01-21.
 */

angular.module('ffApp').controller('RatingsController', ['$scope', '$http', function($scope,$http)
{
	$scope.inprogress = false;

	$scope.init = function()
	{

	};

	$scope.$watch(function(){ return $scope.$parent.currentEpisode.rating; }, function() {
		$scope.renderRating();
	});

	$scope.getPodcastId = function()
	{
		return $scope.$parent.currentEpisode.post_id;
	};

	$scope.getCurrentRating = function()
	{
		return $scope.$parent.currentEpisode.rating;
	};

	$scope.renderRating = function()
	{
		var _rating = $scope.getCurrentRating();
		$scope.getScoreBar().width((_rating*10)+"%");
	};

	$scope.getScoreBar = function()
	{
		return jQuery(".player-meta").find(".ratings-holder").find(".bar.rating");
	};

	$scope.getHoverBar = function()
	{
		return jQuery(".player-meta").find(".ratings-holder").find(".bar.hover");
	};

	$scope.click = function( score )
	{
		if( $scope.inprogress )
		{
			return;
		}
		$scope.inprogress = true;

		$scope.message( currentLanguage == 'sv' ? 'Betygsätter...' : 'Rating...', false );

		var endpoint = templateDirectoryUrl + '/ajax_rate_podcast.php?rating='+score+'&podcast_id='+$scope.getPodcastId()+'&lang='+currentLanguage;

		$http.get( endpoint ).
			then(function(response) {
				var data = response.data;
				$scope.message( data.message, data.status == 'error' ? true : false );
				$scope.inprogress = false;
			}, function(response) {
				var data = response.data;
				$scope.message( data.message, true );
				$scope.inprogress = false;
			});
	};

	$scope.hover = function( num )
	{
		$scope.getHoverBar().width((num*20)+"%");
	};

	$scope.hoverExit = function()
	{
		$scope.getHoverBar().width("0%");
	};

	$scope.message = function( message, is_error )
	{
		var $message = jQuery(".player-meta").find(".ratings-holder").find(".message");
		if( is_error ) {
			$message.addClass('error');
		}
		else {
			$message.removeClass('error');
		}

		$message.text( message );

		$message.fadeIn('fast');

		setTimeout(function()
		{
			$message.fadeOut('fast');
		},5000);
	};
}]);